import { Checkbox, Form, Input, Radio, TextArea } from 'semantic-ui-react'
import { AppDropdown as Dropdown } from 'components/AppDropdown'
import styled from 'styled-components'
import { Controller } from 'react-hook-form'
import { FlexRow, RichTextEditor } from 'components'
import SemanticDatepicker from 'react-semantic-ui-datepickers'
import SignatureCanvas from 'react-signature-canvas'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { AppPrimaryButton } from './Button'
import ReactDatePicker from 'react-datepicker'
import Upload from 'rc-upload'
import ReactSlider from 'react-slider'
import { Check, Eye, EyeClosed, UploadSimple, X } from 'phosphor-react'
import OtpInput from 'react-otp-input';
import { DateUtility } from 'utility'

const StyledSlider = styled(ReactSlider)`
    margin-top: 10px;
    width: 100%;
    height: 5px;
`;

const StyledThumb = styled.div`
    height: 25px;
    line-height: 25px;
    width: 25px;
    text-align: center;
    background-color: #000;
    color: #fff;
    border-radius: 50%;
    cursor: grab;
    top: -10px;
`;

const StyledTrack = styled.div`
top: 0;
bottom: 0;
border-radius: 999px;
background: ${props => (props.index === 2 ? '#f00' : '#ddd')};
`;

const CustomField = styled(Form.Field)`
    .radio-gap {
        gap: 10px;
    }
    .password-icon {
        position: absolute;
        top: 20%;
        right: 10px;
    }
    .relative {
        position: relative;
    }
    width : 100%;
    .error {
        color: ${({ theme }) => theme.colors.danger} !important;
    }
    .field {
        width: 100%;
    }
    .border {
        border: solid 1px #22242626;
        border-radius: 5px;
    }
    .react-datepicker__input-container {
        display: flex;
        align-items: center;
        input {
            padding-left: 30px !important;
        }
    }
    .uploadBox {
        height: 100%; 
        display: flex;
        width: fit-content;
    }
    .rc-uploadBox {  
        height: 100%;
        padding: 20px; 
        justify-content: center;
        align-items:center; 
        border: 2px dashed #cfcfcf; 
        border-radius: 5px;
        textAlign: center;
        align-items: center;
    }
    ${({ height }) => height && "height: 100%;"}
    .sigCanvas {
        width: 300px;
        border: solid 1px #22242626;
        border-radius: 5px;
    }
    .otp-input {
        width: ${({ otpLength }) => ((100 / otpLength) - 5)}% !important;
        input {
            text-align: center;
        }
    }
    .otp {
        justify-content: space-between;
    }
    .app-round {
        border-radius: 50%;
        height: 70px;
        width:70px;
        background:  ${({ theme }) => theme.colors.body} !important;
        border: solid 1px ${({ theme }) => theme.colors.inputbackground};
        .img-preview {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }
        .close-icon {
            position: absolute;
            top: 0px;
            left: 65px;
        
        }
    }
    /* Show red asterisk on labels when field is required */
    ${({ required, theme }) =>
        required && `
        label::after {
            content: ' *';
            color: ${theme.colors.danger};
            font-weight: 700;
        }
    `}
`

export const CustomDropdown = styled(Dropdown)`
    min-width: unset !important;
    overflow-wrap: anywhere !important;

    &.active,
    &.visible {
        z-index: 1100;
    }

    .menu {
        max-height: 200px;
        overflow-y: auto !important;
        border: 1px solid rgba(34, 36, 38, 0.15) !important;
        box-shadow:
            0 2px 4px 0 rgba(34, 36, 38, 0.12),
            0 2px 10px 0 rgba(34, 36, 38, 0.08) !important;
    }

    .item {
        word-wrap: break-word !important;
    }
`

export function FormTextFormField({
    control,
    type,
    name,
    defaultValue,
    width,
    placeholder,
    errors,
    required,
    hint,
    label,
    icon, className, onChange,
    ...rest
}) {
    return (
        <Controller
            control={control}
            name={name}
            defaultValue={defaultValue}
            render={props => {
                const isEmpty = required && !props.field.value;
                const showError = isEmpty && (props.fieldState?.isTouched || props.formState?.isSubmitted);
                return (
                    <CustomField
                        required={required}
                        width={width}
                        small={rest.small}
                        error={!!errors?.message || showError}
                    >
                        {label && (
                            <label className=" ">{label}</label>
                        )}
                        <input
                            placeholder={placeholder}
                            value={props.field.value}
                            onChange={e => {
                                props.field.onChange(e.target.value);
                                if (onChange) {
                                    onChange(e.target.value)
                                }
                            }}
                            onWheel={e => type === 'number' && e.target.blur()}
                            className={className}
                            type={type}
                            style={showError ? { borderColor: '#d32f2f', background: '#fff6f6', color: '#d32f2f' } : {}}
                            {...rest}
                        />
                        {hint && <p>{hint}</p>}
                        {showError && <p className="error" style={{ color: 'red', margin: 0, fontSize: '0.75em' }}>* Required</p>}
                    </CustomField>
                );
            }}
        />
    )
}

export function FormPasswordFormField({
    control,
    name,
    defaultValue,
    width,
    placeholder,
    errors,
    required,
    hint,
    label,
    icon, className, onChange,
    ...rest
}) {
    const [open, setOpen] = useState(false)
    return (
        <Controller
            control={control}
            name={name}
            defaultValue={defaultValue}
            render={props => (
                <CustomField
                    required={required}
                    width={width}
                    small={rest.small}
                    error={!!errors?.message}
                >
                    {label && (
                        <label className=" ">{label}</label>
                    )}
                    <div className="relative">
                        <input
                            placeholder={placeholder}
                            value={props.field.value}
                            onChange={e => {
                                props.field.onChange(e.target.value);
                                if (onChange) {
                                    onChange(e.target.value)
                                }
                            }}
                            className={className}
                            {...rest}
                            type={open ? "text" : "password"}
                        />
                        <div className="password-icon" onClick={() => setOpen(!open)}>{open ? <Eye size={20} /> : <EyeClosed size={20} />}</div>
                    </div>
                    {hint && <p>{hint}</p>}
                    {errors?.message && <p className="error">{errors?.message}</p>}
                </CustomField>
            )}
        />
    )
}

export function FormRadioField({
    control,
    name,
    defaultValue,
    width,
    placeholder,
    errors,
    required,
    row,
    options,
    hint,
    label,
    icon, className, onChange,
    ...rest
}) {
    return (
        <Controller
            control={control}
            name={name}
            defaultValue={defaultValue}
            render={props => (
                <CustomField
                    required={required}
                    width={width}
                    small={rest.small}
                    error={!!errors?.message}
                >
                    {label && (
                        <label className=" ">{label}</label>
                    )}
                    <div className={`d-flex ${row ? "flex-row" : "flex-column"} radio-gap`}>
                        {options?.map(ele => <FlexRow
                            className=""
                            key={ele.Id}
                        >
                            <div onClick={() => {
                                props.field.onChange(ele.Id);
                                if (onChange) {
                                    onChange(ele.Id)
                                }
                            }}>
                                <Radio
                                    placeholder={placeholder}
                                    name={name}
                                    checked={props.field.value === ele.Id}
                                    onChange={() => {
                                        props.field.onChange(ele.Id);
                                        if (onChange) {
                                            onChange(ele.Id)
                                        }
                                    }}
                                    className={className}
                                    {...rest}
                                />
                                <label className="ms-2">{ele.name}</label>
                            </div>
                        </FlexRow>)}
                    </div>
                    {hint && <p>{hint}</p>}
                    {errors?.message && <p className="error">{errors?.message}</p>}
                </CustomField>
            )}
        />
    )
}

export function FormTextAreaFormField({
    control,
    name,
    defaultValue,
    width,
    placeholder,
    errors, height,
    required,
    hint,
    label,
    onChange,
    ...rest
}) {
    return (
        <Controller
            control={control}
            name={name}
            defaultValue={defaultValue}
            render={props => {
                const isEmpty = required && !props.field.value;
                const showError = isEmpty && (props.fieldState?.isTouched || props.formState?.isSubmitted);
                return (
                    <CustomField
                        required={required}
                        width={width}
                        height={height}
                        error={!!errors?.message || showError}
                    >
                        {label && (
                            <label className="">{label}</label>
                        )}
                        <textarea
                            placeholder={placeholder}
                            value={props.field.value || ""}
                            onChange={e => {
                                props.field.onChange(e.target.value);
                                if (onChange) {
                                    onChange(e.target.value);
                                }
                            }}
                            {...rest}
                        />
                        {hint && <p>{hint}</p>}
                        {showError && <p className="error" style={{ color: 'red', margin: 0, marginTop: '2px', fontSize: '0.75em' }}>* Required</p>}
                    </CustomField>
                )
            }}
        />
    )
}

function FormDropdownFieldComponent(
    {
        control,
        name,
        defaultValue,
        width,
        placeholder,
        errors,
        required,
        options,
        label,
        onChange,
        ...rest
    },
    ref,
) {
    return (
        <Controller
            control={control}
            name={name}
            defaultValue={defaultValue}
            render={props => {
                const isEmpty = required && (!props.field.value || (Array.isArray(props.field.value) ? props.field.value.length === 0 : props.field.value === ''));
                // Show error only after touch or submit to avoid pre-submit noise
                const showError = isEmpty && (props.fieldState?.isTouched || props.formState?.isSubmitted);
                const handleChange = (event, item) => {
                    props.field.onChange(item?.value ?? '')
                    onChange?.(event, item)
                }
                return (
                    <CustomField
                        required={required}
                        width={width}
                        error={!!errors?.message || showError}
                    >
                        {label && (
                            <label className=" ">{label}</label>
                        )}
                        <CustomDropdown
                            ref={ref}
                            placeholder={placeholder}
                            value={props.field.value}
                            selectOnBlur={false}
                            selection
                            search
                            options={options}
                            onChange={handleChange}
                            style={showError ? { borderColor: '#d32f2f', background: '#fff6f6', color: '#d32f2f', marginBottom: 0 } : { marginBottom: 0 }}
                            {...rest}
                        />
                        {showError && (
                            <p className="error" style={{ color: 'red', margin: 0, marginTop: '2px', fontSize: '0.75em' }}>* Required</p>
                        )}
                    </CustomField>
                );
            }}
        />
    )
}

FormDropdownFieldComponent.displayName = 'FormDropdownField'

export const FormDropdownField = React.forwardRef(FormDropdownFieldComponent)

export function FormDateField({
    control,
    name,
    defaultValue,
    width,
    placeholder,
    errors,
    required,
    options,
    label,
    type,
    position,
    disabledBefore,
    ...rest
}) {
    return (
        <Controller
            control={control}
            name={name}
            defaultValue={defaultValue}
            render={props => {
                const isEmpty = required && !props.field.value;
                const showError = isEmpty && (props.fieldState?.isTouched || props.formState?.isSubmitted);
                return (
                    <CustomField
                        required={required}
                        width={width}
                        error={!!errors?.message || showError}
                    >
                        {label && (
                            <label className=" ">{label}</label>
                        )}
                        <SemanticDatepicker
                            placeholder={placeholder}
                            value={props.field.value}
                            type={type}
                            width="100%"
                            pointing={position}
                            filterDate={(date) => {
                                if (disabledBefore && DateUtility.differenceInSeconds(date, disabledBefore) < 0) {
                                    return false
                                }
                                return true
                            }}
                            locale="en-US"
                            onChange={(_, date) => props.field.onChange(date.value)}
                            style={showError ? { borderColor: '#d32f2f', background: '#fff6f6', color: '#d32f2f', marginBottom: 0 } : { marginBottom: 0 }}
                            {...rest}
                        />
                        {showError && (
                            <p className="error" style={{ color: 'red', margin: 0, marginTop: '2px', fontSize: '0.75em' }}>* Required</p>
                        )}
                    </CustomField>
                );
            }}
        />
    )
}

export function FormDateTimeField({
    control,
    name,
    defaultValue,
    width,
    placeholder,
    errors,
    required,
    label,
    position,
    onChange,
    ...rest
}) {
    return (
        <Controller
            control={control}
            name={name}
            defaultValue={defaultValue}
            render={props => {
                const isEmpty = required && !props.field.value;
                const showError = (isEmpty || errors) && (props.fieldState?.isTouched || props.formState?.isSubmitted);

                // Convert Date object to YYYY-MM-DDTHH:mm string for datetime-local input
                let { value } = props.field;
                if (value instanceof Date && !Number.isNaN(value.getTime())) {
                    const pad = n => n.toString().padStart(2, '0');
                    value = `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}T${pad(value.getHours())}:${pad(value.getMinutes())}`;
                } else if (typeof value === 'string' && value.includes('T')) {
                    // Already a string, potentially from the backend
                    value = value.substring(0, 16);
                } else {
                    value = '';
                }

                return (
                    <CustomField
                        required={required}
                        width={width}
                        error={!!errors?.message || showError}
                    >
                        {label && (
                            <label className=" ">{label}</label>
                        )}
                        <Input
                            type="datetime-local"
                            placeholder={placeholder}
                            value={value}
                            onChange={(_, data) => {
                                const newDate = data.value ? new Date(data.value) : null;
                                props.field.onChange(newDate);
                                if (onChange) {
                                    onChange(newDate);
                                }
                            }}
                            onBlur={props.field.onBlur}
                            error={!!errors?.message || showError}
                            fluid
                            icon="calendar"
                            iconPosition="left"
                            {...rest}
                        />
                        {showError && (
                            <p className="error" style={{ color: 'red', margin: 0, marginTop: '2px', fontSize: '0.75em' }}>
                                {errors?.message || '* Required'}
                            </p>
                        )}
                    </CustomField>
                );
            }}
        />
    )
}

export function FormToggleFormField({
    control,
    name,
    defaultValue,
    width,
    placeholder,
    errors,
    required,
    options,
    label,
    type,
    position,
    ...rest
}) {
    const readPath = (obj, path) => {
        if (!obj || !path) return undefined
        return String(path)
            .split('.')
            .filter(Boolean)
            .reduce((acc, key) => (acc != null ? acc[key] : undefined), obj)
    }

    // If caller doesn't provide a defaultValue, prefer RHF's defaultValues for this field
    // so nested defaults like `QuestionDisplaySetting.IsMediaAllowed: true` are honored.
    const resolvedDefaultValue =
        defaultValue !== undefined
            ? defaultValue
            : readPath(control?._defaultValues, name)

    return (
        <Controller
            control={control}
            name={name}
            defaultValue={resolvedDefaultValue}
            render={props => (
                <CustomField
                    required={required}
                    width={width}
                    error={!!errors?.message}
                >
                    {label && (
                        <label className=" ">{label}</label>
                    )}
                    <Radio
                        className="mt-2"
                        toggle
                        checked={!!props.field.value}
                        onChange={(_, data) => {
                            // semantic-ui can sometimes provide `checked` as `undefined`.
                            // Force a real boolean so unchecked never becomes `undefined`
                            // (which then breaks API payload building).
                            props.field.onChange(!!data?.checked)
                        }}
                        {...rest}
                    />
                    {errors?.message && <p className="error">{errors?.message}</p>}
                </CustomField>
            )}
        />
    )
}

export function FormCheckBoxField({
    control,
    name,
    defaultValue,
    width,
    placeholder,
    errors,
    required,
    options,
    label,
    type,
    position,
    onChange,
    ...rest
}) {
    return (
        <Controller
            control={control}
            name={name}
            defaultValue={defaultValue}
            render={props => (
                <CustomField
                    required={required}
                    width={width}
                    error={!!errors?.message}
                >
                    <FlexRow className="d-flex align-items-center">
                        <Checkbox
                            className=""
                            checked={props.field.value}
                            onChange={(_, data) => {
                                props.field.onChange(data.checked)
                                if (typeof onChange === 'function') {
                                    try { onChange(data.checked) } catch { /* no-op */ }
                                }
                            }}
                            {...rest}
                        />
                        {label && (
                            <label
                                onClick={() => {
                                    props.field.onChange(!props.field.value)
                                    if (typeof onChange === 'function') {
                                        try { onChange(!props.field.value) } catch { /* no-op */ }
                                    }
                                }}
                                className="ms-2 f-700">{label}</label>
                        )}
                    </FlexRow>
                    {errors?.message && <p className="error">{errors?.message}</p>}
                </CustomField>
            )}
        />
    )
}

export function FormColorFormField({
    control,
    name,
    defaultValue,
    width,
    placeholder,
    errors,
    required,
    hint,
    label,
    icon,
    className, height, onChange,
    ...rest
}) {
    return (
        <Controller
            control={control}
            name={name}
            defaultValue={defaultValue}
            render={props => (
                <CustomField
                    required={required}
                    width={width}
                    small={rest.small}
                    error={!!errors?.message}
                >
                    {label && (
                        <label className=" ">{label}</label>
                    )}
                    <input
                        type="color"
                        placeholder={placeholder}
                        value={props.field.value}
                        onChange={e => {
                            props.field.onChange(e.target.value);
                            if (onChange) {
                                onChange(e.target.value)
                            }
                        }}
                        className={className}
                        style={{ height }}
                        {...rest}
                    />
                    {hint && <p>{hint}</p>}
                    {errors?.message && <p className="error">{errors?.message}</p>}
                </CustomField>
            )}
        />
    )
}

export function FormOTPField({
    control,
    name,
    defaultValue,
    width,
    otpLength = 4,
    errors,
    required,
    hint,
    label,
    onChange,
    ...rest
}) {
    const [otp, setOtp] = useState(defaultValue || '');

    return (
        <Controller
            control={control}
            name={name}
            defaultValue={otp}
            render={props => (
                <CustomField
                    required={required}
                    width={width}
                    small={rest.small}
                    error={!!errors?.message}
                    otpLength={otpLength}
                >
                    {label && (
                        <label>{label}</label>
                    )}
                    <OtpInput
                        {...props.field}
                        value={props.field.value}
                        onChange={(otp) => {
                            props.field.onChange(otp);
                            setOtp(otp);
                            if (onChange) {
                                onChange(otp);
                            }
                        }}
                        renderInput={(props) => <Input {...props} />}
                        numInputs={otpLength}
                        renderSeparator={<span> - </span>}
                        containerStyle="otp"
                        inputStyle="otp-input"
                    />
                    {hint && <p>{hint}</p>}
                    {errors?.message && <p className="error">{errors?.message}</p>}
                </CustomField>
            )}
        />
    );
}

export const RTEFormField = ({
    required, errors, label, control, name, defaultValue, width, fieldClass,
}) => (
    <Controller
        control={control}
        name={name}
        defaultValue={defaultValue}
        render={(props) => (
            <CustomField required={required} error={errors} width={width} className={fieldClass}>
                {label && <label>{label}</label>}
                <div className="mt-2">
                    <RichTextEditor
                        value={props.field.value}
                        onChange={props.field.onChange}
                        onBlur={props.field.onBlur}
                        name={name}
                    />
                </div>
                {errors?.message && <p className="error">{errors?.message}</p>}
            </CustomField>
        )}
    />
);

export const RTEFormWithoutControllerField = ({
    required, errors, label, width, fieldClass, onChange, value, name,
}) => (
    <CustomField required={required} error={errors} width={width} className={fieldClass}>
        {label && <label>{label}</label>}
        <div className="mt-2">
            <RichTextEditor
                value={value}
                onChange={onChange}
                name={name}
            />
        </div>
        {errors?.message && <p className="error">{errors?.message}</p>}
    </CustomField>
);

export const SignatureFormField = ({

    required,
    error,
    label,
    width,
    fieldClass,
    onChange,
    value,
}) => {
    const signatureRef = useRef();
    const [isSignatureSaved, setIsSignatureSaved] = useState(false)
    const [hasSignatureStroke, setHasSignatureStroke] = useState(false)

    const getNormalizedSignatureDataUrl = (rawValue) => {
        if (!rawValue || typeof rawValue !== 'string') return ''
        const trimmedValue = rawValue.trim()
        if (!trimmedValue) return ''
        if (trimmedValue.startsWith('data:image')) return trimmedValue
        if (trimmedValue.startsWith('image/')) return `data:${trimmedValue}`
        return `data:image/png;base64,${trimmedValue}`
    }

    useEffect(() => {
        const normalizedValue = getNormalizedSignatureDataUrl(value)
        if (normalizedValue && signatureRef.current) {
            signatureRef.current.fromDataURL(normalizedValue, {
                width: 300,
                height: 200,
            });
            setIsSignatureSaved(true)
            setHasSignatureStroke(true)
            return
        }
        setIsSignatureSaved(false)
        setHasSignatureStroke(false)
    }, [value]);

    const clearSignature = () => {
        if (signatureRef.current) {
            signatureRef.current.clear();
            onChange("")
            setIsSignatureSaved(false)
            setHasSignatureStroke(false)
        }
    };

    const saveSignature = () => {
        if (!signatureRef.current || signatureRef.current.isEmpty()) {
            return
        }
        const data = signatureRef.current.toDataURL();
        onChange(data)
        setIsSignatureSaved(true)
    };

    return (

        <CustomField required={required} error={error?.message} width={width} className={fieldClass}>
            <div className="">
                {label && <label>{label}</label>}
                <SignatureCanvas
                    penColor="green"
                    canvasProps={{ width: 300, height: 200, className: 'sigCanvas' }}
                    ref={signatureRef}
                    onEnd={() => {
                        setHasSignatureStroke(true)
                        setIsSignatureSaved(false)
                    }}
                />
            </div>
            <div className="mt-3">
                <AppPrimaryButton onClick={clearSignature}>Clear</AppPrimaryButton>
                <AppPrimaryButton
                    onClick={saveSignature}
                    disabled={isSignatureSaved || !hasSignatureStroke}
                    style={
                        isSignatureSaved
                            ? {
                                backgroundColor: '#16a34a',
                                borderColor: '#16a34a',
                                opacity: 0.85,
                                cursor: 'not-allowed',
                            }
                            : undefined
                    }
                >
                    {isSignatureSaved ? (
                        <span className="d-inline-flex align-items-center gap-1">
                            <Check size={14} weight="bold" />
                            Saved
                        </span>
                    ) : (
                        'Save'
                    )}
                </AppPrimaryButton>
            </div>
        </CustomField>
    )
};

export const DateTimeFormFieldWithoutControl = ({
    required, error, width, fieldClass, onChange, placeholder, selected, ...rest
}) => {
    const safeSelected = useMemo(() => {
        if (selected === undefined || selected === null || selected === '') {
            return null
        }
        const date =
            selected instanceof Date ? selected : new Date(selected)
        return Number.isNaN(date.getTime()) ? null : date
    }, [selected])

    return (
        <CustomField required={required} error={error} width={width} className={fieldClass}>
            <ReactDatePicker
                showIcon
                selected={safeSelected}
                onChange={onChange}
                placeholderText={placeholder}
                {...rest}
            />
        </CustomField>
    )
};

export const AppUpload = ({ onChange, label = "", files = [], multiple = false, accept, errors, onRemove }) => {
    return (<CustomField height className="0">
        <label>{label}</label>
        <Upload
            accept={accept || ".jpg,.png,.jpeg,.pdf,.xlsx"}
            multiple={multiple}
            onStart={onChange}
            className="uploadBox"
            customRequest={() => { return true }}
        >
            <div className="app-round d-flex justify-content-center align-items-center">
                <>
                    {(files?.length && (files?.[0]?.url || files[0]?.type)) ? <div className="relative img-preview">
                        <img className="" src={files?.[0]?.url || URL.createObjectURL(files[0])} alt="" />
                        <X onClick={(e) => { e.stopPropagation(); onRemove(files[0]) }} className="close-icon pointer" />
                    </div> : <UploadSimple size={30} />}
                </>
            </div>
        </Upload>
        {errors && <p className="error mt-2">{errors}</p>}
    </CustomField>)
}

export const Slider = ({ onChange, value }) => {
    const Thumb = (props, state) => <StyledThumb {...props}>{state.valueNow}</StyledThumb>;
    const Track = (props, state) => <StyledTrack {...props} index={state.index} />;
    const numericValue =
        typeof value === 'number' && !Number.isNaN(value)
            ? value
            : Number(value) || 0
    return (<StyledSlider defaultValue={numericValue} value={numericValue} onAfterChange={onChange} renderTrack={Track} renderThumb={Thumb} />)
}

export function TextAreaFormField({
    error,
    onChange,
    onBlur,
    value,
    placeholder,
}) {
    return (

        <CustomField
            error={!!error?.message}
        >
            <TextArea
                error={error}
                value={value}
                onBlur={onBlur}
                onChange={onChange}
                placeholder={placeholder}
            />
        </CustomField>
    )
}